import 'css-chunksrc/client/scenes/fillAccount/styles.scss';export default {
  "fillAccount": "_fillAccount_1d1a5_1",
  "row": "_row_1d1a5_10",
  "group": "_group_1d1a5_21",
  "message": "_message_1d1a5_25",
  "redirection": "_redirection_1d1a5_31",
  "label": "_label_1d1a5_35",
  "input": "_input_1d1a5_41",
  "invalid": "_invalid_1d1a5_46",
  "submitButton": "_submitButton_1d1a5_50",
  "main": "_main_1d1a5_68",
  "title": "_title_1d1a5_79",
  "redirectionButton": "_redirectionButton_1d1a5_84"
};